var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 5.02734V8.75734C11 9.90234 10.07 10.8273 8.925 10.8273H3.075C1.93 10.8273 1 9.90234 1 8.75734V5.02734H11Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.29754V5.02754H1V4.29754C1 3.15254 1.93 2.22754 3.075 2.22754H8.925C10.07 2.22754 11 3.15254 11 4.29754Z",
    fill: "#7C7C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.15234H3C2.795 9.15234 2.625 8.98234 2.625 8.77734C2.625 8.57234 2.795 8.40234 3 8.40234H4C4.205 8.40234 4.375 8.57234 4.375 8.77734C4.375 8.98234 4.205 9.15234 4 9.15234Z",
    fill: "#7C7C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.15234H5.25C5.045 9.15234 4.875 8.98234 4.875 8.77734C4.875 8.57234 5.045 8.40234 5.25 8.40234H7.25C7.455 8.40234 7.625 8.57234 7.625 8.77734C7.625 8.98234 7.455 9.15234 7.25 9.15234Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNumber);
export default __webpack_public_path__ + "static/media/CardNumber.daa91b9c74c008473be50c76c8c51b5d.svg";
export { ForwardRef as ReactComponent };